<template>
  <el-autocomplete ref="autocomplete" value-key="value" v-scrollLoad="selectLoadMore" v-loading="loading"
    v-model="state" :fetch-suggestions="querySearch" :placeholder="placeholder" :trigger-on-focus="false"
    @select="handleSelect" @blur="handleBlur"></el-autocomplete>
</template>

<script>
export default {
  name: 'InputLoadMore',
  props: {
    // 封装的查数据方法
    getOptionFn: {
      type: Function,
      required: true
    },
    // 后端定义的联想的key
    searchKey: {
      type: String,
      required: true
    },
    // v-model的绑定值
    value: {
      type: String,
      default: ''
    },
    // placehoder
    placeholder: {
      type: String,
      default: '请输入'
    },
    // 额外的查询参数
    extraParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      state: '',
      loading: false,
      page: 1,
      pageTotal: 0,
      lastConfirmedValue: ''
    }
  },
  watch: {
    state(val) {
      this.$emit('input', val)
    },
    value: {
      immediate: true,
      handler(val) {
        this.state = val;
        this.lastConfirmedValue = val;
      }
    }
  },
  mounted() {
    // 初始化时设置值，确保回显
    this.state = this.value
  },
  directives: {
    // 自定义指令，监听下拉框的滚动，滚动到底部就加载下一页
    scrollLoad: {
      bind(el, binding, vnode) {
        let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap')
        let listDom = el.querySelector('.el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list')
        if (wrapDom && listDom) {
          wrapDom.addEventListener(
            'scroll',
            e => {
              // 注意load的使用，节流
              let condition = wrapDom.offsetHeight + wrapDom.scrollTop + 10 - listDom.offsetHeight
              if (condition > 0 && !vnode.context.loading) {
                //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
                binding.value()
              }
            },
            false
          )
        }
      }
    }
  },
  methods: {
    async querySearch(queryString, cb) {
      this.page = 1
      this.loading = true
      try {
        const params = {
          page: 1,
          pageSize: 50,
          [this.searchKey]: queryString,
          ...this.extraParams
        }

        let response = await this.getOptionFn(params)

        // 处理 API 返回的数据结构
        if (response && response.data && response.data.data) {
          let arr = []
          response.data.data.forEach(item => {
            // 过滤掉 diagnosisName 或 dictLabel 为 null 或空的数据
            const name = item.diagnosisName || item.dictLabel
            if (name && name !== null && name !== '') {
              arr.push({
                value: name,
                label: name,
                code: item.diagnosisCode || item.dictValue || '',
                dictLabel: name,
                dictValue: item.diagnosisCode || item.dictValue || '',
                ...item
              })
            }
          })
          cb(arr)
        } else {
          cb([])
        }
        this.pageTotal = response.data.count || 0
      } catch (e) {
        console.error('查询失败:', e)
        cb([])
      } finally {
        this.loading = false
      }
    },
    handleSelect(item) {
      this.lastConfirmedValue = item.value;
      this.$emit('select', item)
    },
    handleBlur() {
      setTimeout(() => {
        if (this.state === '') {
          this.lastConfirmedValue = '';
          this.$emit('input', '');
          this.$emit('select', { value: '', code: '', dictValue: '' });
        }
        else if (this.state !== this.lastConfirmedValue) {
          const suggestions = this.$refs['autocomplete'].$data.suggestions || [];
          const exactMatch = suggestions.find(item => item.value === this.state);

          if (exactMatch) {
            this.lastConfirmedValue = exactMatch.value;
            this.$emit('select', exactMatch);
          } else {
            this.state = this.lastConfirmedValue || '';
            this.$emit('input', this.state);
          }
        }
        this.$emit('blur');
      }, 200);
    },
    // 加载更多
    async selectLoadMore() {
      // 检查是否还有更多数据需要加载
      if (Number(this.pageTotal) <= this.$refs['autocomplete'].$data.suggestions.length) {
        return
      }
      this.page = this.page + 1
      this.loading = true
      try {
        const params = {
          page: this.page,
          pageSize: 50,
          [this.searchKey]: this.state,
          ...this.extraParams
        }

        let response = await this.getOptionFn(params)

        // 处理 API 返回的数据结构
        if (response && response.data && response.data.data) {
          const arr = []
          response.data.data.forEach(item => {
            // 过滤掉 diagnosisName 或 dictLabel 为 null 或空的数据
            const name = item.diagnosisName || item.dictLabel
            if (name && name !== null && name !== '') {
              arr.push({
                value: name,
                label: name,
                code: item.diagnosisCode || item.dictValue || '',
                dictLabel: name,
                dictValue: item.diagnosisCode || item.dictValue || '',
                ...item
              })
            }
          })
          // 将数据添加到下拉列表
          this.$refs['autocomplete'].$data.suggestions = this.$refs['autocomplete'].$data.suggestions.concat(arr)
        }
        this.pageTotal = response.data.count || 0
      } catch (e) {
        console.error('加载更多失败:', e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
